<template>
  <div>
    <slot name="label">
      <label
        v-if="label"
        class="col-form-label col-lg-3 col-sm-12"
        :class="labelClasses"
      >
        {{ label }}
        <span v-if="required" class="text-danger">*</span>
      </label>
    </slot>

    <slot>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <input
          :value="value"
          :class="inputClasses"
          :name="name"
          @input="$emit('input', $event.target.value)"
          v-bind="$attrs"
          class="form-control"
          aria-describedby="addon-right addon-left"
        />
        <span v-if="helpText" class="form-text text-muted">{{ helpText }}</span>
      </div>
    </slot>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: 'base-inline-input',
  props: {
    required: {
      type: Boolean,
      description: 'Whether input is required (adds an asterix *)',
    },

    label: {
      type: String,
      description: 'Input label (text before input)',
    },
    helpText: {
      type: String,
      description: 'Input help text (text after input)',
    },

    inline: {
      type: Boolean,
      description: 'Inline Input',
    },

    formClasses: {
      type: String,
      description: 'Form css classes',
    },
    labelClasses: {
      type: String,
      description: 'Input label css classes',
    },
    inputClasses: {
      type: String,
      description: 'Input css classes',
    },
    value: {
      type: [String, Number],
      description: 'Input value',
    },
    name: {
      type: [String, Number],
      description: 'Input Name',
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
<style></style>
